import React, { useEffect, useState, useRef } from 'react';
import BannerImg from '../../../assets/Illustration/Energy-monitoring.png';

const BannerWithFadingGridBackground = () => {
  const gridItems = Array.from({ length: 60 });

  const [isTextVisible, setIsTextVisible] = useState(false);
  const [isImageVisible, setIsImageVisible] = useState(false);

  const textRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target === textRef.current) {
            setIsTextVisible(entry.isIntersecting);
          }
          if (entry.target === imageRef.current) {
            setIsImageVisible(entry.isIntersecting);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (textRef.current) observer.observe(textRef.current);
    if (imageRef.current) observer.observe(imageRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div className='relative min-h-screen flex flex-col justify-center px-8'>
      {/* Grid Background */}
      <div className='absolute inset-0'>
        <div
          className='grid grid-cols-8 grid-rows-8 w-full h-full opacity-10 dark:opacity-10'
          style={{
            maskImage: 'linear-gradient(to bottom, black 30%, transparent 70%)',
            WebkitMaskImage:
              'linear-gradient(to bottom, black 30%, transparent 70%)',
          }}
        >
          {gridItems.map((_, index) => (
            <div
              key={index}
              className='border border-black dark:border-gray-400'
            />
          ))}
        </div>
      </div>

      {/* Heading */}
      <div
        ref={textRef}
        className={`relative max-w-4xl mx-auto text-center transition-transform duration-1000 ease-in-out ${
          isTextVisible
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 -translate-y-10'
        }`}
      >
        <h1 className='text-4xl md:text-6xl font-bold text-gray-800 dark:text-gray-100 leading-tight'>
          Optimize Energy Usage through Real-Time Energy Monitoring
        </h1>
      </div>

      {/* Centered Image */}
      <div className='relative mt-16 w-full flex justify-center'>
        <div
          ref={imageRef}
          className={`w-full flex justify-center transition-transform duration-1000 ease-in-out ${
            isImageVisible
              ? 'opacity-100 translate-y-0'
              : 'opacity-0 translate-y-10'
          }`}
        >
          <img
            src={BannerImg}
            alt='banner-img'
            className='w-full max-w-4xl md:min-h-[360px] object-contain rounded-xl shadow-2xl'
          />
        </div>
      </div>
    </div>
  );
};

export default BannerWithFadingGridBackground;
